export default "__VITE_ASSET__CVFieL$$__"